import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutusComponent } from './aboutus/aboutus.component';
import { AuthProfileComponent } from './auth-profile/auth-profile.component';
import { PlansComponent } from './plans/plans.component';
import { ScholarshipsComponent } from './scholarships/scholarships.component';


const routes: Routes = [
  {path:'profile',component:AuthProfileComponent},
  {path:'plans',component:PlansComponent},
  {path:'scholarships',component:ScholarshipsComponent},
  {path:'aboutus',component:AboutusComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
